import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ATTEMPT = `${TASK_SERVICE}/me`;

/**
 * Fetches the current user's work items.
 *
 * @function
 * @memberof me
 * @async
 * @param {Object} [options={}] - Options for the request.
 * @param {Object} [options.filters] - Filtering criteria for the request.
 * @param {Object} [options.sort] - Sorting criteria for the request.
 * @param {Object} [options.params] - Additional query parameters.
 * @param {AbortSignal} [options.signal] - Optional signal to abort the request.
 * @param {Object} [options.toastMessageConfig] - Configuration for toast messages.
 * @param {number} [options.top] - Number of items to fetch.
 * @param {number} [options.skip] - Number of items to skip.
 * @returns {Promise<any>} The API response containing the user's work items.
 */
export const me = {
  myWork: async ({
    filters,
    sort,
    params,
    signal,
    toastMessageConfig,
    top,
    skip,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ATTEMPT}/mywork`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
